/* eslint-disable no-dupe-keys */
export default {
  coupon: {
    name: '用户优惠券',
    // 属性（一般与对象内容匹配）
    prop: {
      coupon_definition: '优惠券',
      gift_card: '礼品卡',
      user: '用户',
      source_description: '来源',
      created_at: '兑换时间',
      begin_time: '生效时间',
      end_time: '失效日期',
      used_time: '使用时间',
      charging_discount: '消费订单',
      status: '状态',
      has_settled: '是否结算'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    // Enum的属性
    statuses: {
      unused: '未使用',
      used: '已使用',
      expired: '已过期',
      disabled: '已禁用'
    },
    has_settleds: {
      true: '已结算',
      false: '未结算'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询来源'
    },
    // 详情页标签
    labels: {
      amount: '实付金额',
      coupon_discount_amount: '优惠折扣',
      status_available: '可用',
      status_disabled: '不可用'
    }
  }
}
